import React, { Component } from "react";
import { Row, Col } from "react-flexbox-grid";
import Paper from "material-ui-next/Paper";
import Typography from "material-ui-next/Typography";
import { SelectField, TextField } from "components/support";

export default class FilterView extends Component {
  static types = [
    { value: "", label: "Selecione uma opção" },
    { value: "in", label: "Entrada" },
    { value: "out", label: "Retirada" }
  ];

  render() {
    const { operationType, note, errors, onChangeOperation } = this.props;

    return (
      <Paper elevation={1} className="p-sm mb-md">
        <Typography type="headline">Operação</Typography>
        <Row>
          <Col xs={12} lg={6}>
            <SelectField
              fullWidth
              label="Tipo de Operação"
              value={operationType}
              onChange={(_, value) => onChangeOperation("operationType", value)}
              options={FilterView.types}
              errorText={errors.operationType}
            />
          </Col>
          <Col xs={12} lg={6}>
            <TextField
              fullWidth
              label="Observação"
              value={note}
              onChange={(_, value) => onChangeOperation("note", value)}
            />
          </Col>
        </Row>
      </Paper>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/app/registration/product/inventory/modify/operation/index.jsx